import { initializeApp } from "firebase/app";
import { getAuth, OAuthProvider } from "firebase/auth";

// const firebaseConfig = {
//   apiKey: import.meta.env.VITE_FIREBASE_API_KEY,
//   authDomain: import.meta.env.VITE_FIREBASE_AUTH_DOMAIN,
//   projectId: import.meta.env.VITE_FIREBASE_PROJECT_ID,
//   appId: import.meta.env.VITE_FIREBASE_APP_ID,
// };

let _app = null;
let _auth = null;

async function initFirebaseIfNeeded() {
  // 認証済みならそのまま返す
  if (_auth) return;

  // Firebase Hosting の予約URL/__/firebase/init.json を fetch して config を取る
  const res = await fetch("/__/firebase/init.json");
  if (!res.ok) {
    throw new Error(`Failed to load Firebase config: ${res.status} ${res.statusText}`);
  }

  const firebaseConfig = await res.json();
  firebaseConfig.authDomain = window.location.host; // アプリ提供ドメインをauthDomainにする（本来はfirebase.comのドメインになるが、カスタムドメインを指定）
  _app = initializeApp(firebaseConfig); // modular初期化の基本形 
  _auth = getAuth(_app);                // Authを取得
}

export async function getFirebaseAuth() {
  await initFirebaseIfNeeded();

  return _auth;
}

// Microsoftのプロバイダーを作成
export function createMicrosoftProvider({ tenant } = {}) {
  const provider = new OAuthProvider("microsoft.com");
  if (tenant) provider.setCustomParameters({ tenant });
  return provider;
}
